import { render, staticRenderFns } from "./auditing.vue?vue&type=template&id=bb6b0aa0&scoped=true&"
import script from "./auditing.vue?vue&type=script&lang=ts&"
export * from "./auditing.vue?vue&type=script&lang=ts&"
import style0 from "./auditing.vue?vue&type=style&index=0&id=bb6b0aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b0aa0",
  null
  
)

export default component.exports